import { Navigate } from 'react-router-dom';

import { useSelector } from 'react-redux';
import Logo from '../assets/app/logo.png'
import { Toaster } from 'react-hot-toast';

const AuthLayout = ({ component: Component, ...props }) => {

    const { user } = useSelector((state) => state.auth);
   
    if (user != null) {
        return <Navigate to={'/'} replace />;
    }

    return (
        <div className="min-h-screen w-full bg-gray-50 flex items-center justify-center px-4 py-8">
            <div className="w-full max-w-md bg-white rounded-2xl shadow-lg border border-gray-100 p-6 sm:p-8">
                <img src={Logo} alt='Ioparla' className='mx-auto mb-6 max-w-[140px]' />
                <Toaster />
                <Component {...props} />
            </div>
        </div>
    );
};

export { AuthLayout };
